import { Reveal, Eyebrow } from "./Reveal";
import Magnetic from "./Magnetic";
import { scrollToId } from "@/lib/scroll";

const Molecule = ({ tone }) => (
  <svg viewBox="0 0 120 120" className="w-24 h-24" fill="none" aria-hidden="true">
    <circle cx="60" cy="34" r="14" stroke={tone} strokeWidth="1.2" opacity="0.9" />
    <circle cx="34" cy="78" r="10" stroke={tone} strokeWidth="1.2" opacity="0.6" />
    <circle cx="88" cy="76" r="12" stroke={tone} strokeWidth="1.2" opacity="0.75" />
    <line x1="52" y1="46" x2="40" y2="69" stroke={tone} strokeWidth="1" opacity="0.5" />
    <line x1="70" y1="45" x2="81" y2="66" stroke={tone} strokeWidth="1" opacity="0.5" />
    <line x1="44" y1="78" x2="76" y2="76" stroke={tone} strokeWidth="1" opacity="0.5" />
  </svg>
);

const Formula = () => (
  <section id="formula" data-testid="formula-section" className="bg-[#FAF7F5] py-24 sm:py-36">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <Eyebrow>The formula</Eyebrow>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className="font-serif font-light text-[#1C1417] text-4xl sm:text-6xl tracking-tight mt-5 max-w-3xl text-balance leading-[1.04]">
          Hydration science, <span className="italic text-[#A31D4F]">Italian craftsmanship.</span>
        </h2>
      </Reveal>

      <div className="mt-14 grid md:grid-cols-2 gap-5">
        <Reveal delay={0.1}>
          <div
            data-testid="formula-ha-card"
            className="group relative rounded-[28px] bg-white border border-[#EADECE] p-8 sm:p-12 overflow-hidden hover:shadow-[0_30px_60px_-30px_rgba(163,29,79,0.3)] transition-shadow duration-500"
          >
            <div className="flex items-start justify-between">
              <Molecule tone="#A31D4F" />
              <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#6E6266] border border-[#EADECE] rounded-full px-3 py-1.5">
                Active 01
              </span>
            </div>
            <p className="font-mono text-4xl sm:text-5xl text-[#A31D4F] mt-8 tracking-tight">20<span className="text-2xl align-top"> mg/mL</span></p>
            <p className="font-serif text-2xl sm:text-3xl text-[#1C1417] mt-3">Hyaluronic Acid</p>
            <p className="text-sm text-[#6E6266] font-light leading-relaxed mt-4 max-w-md">
              A naturally occurring molecule loved for its ability to bind water. In Skinfill Bacio it is selected to
              support deep, lasting lip hydration and a smoother-looking lip surface.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.18}>
          <div
            data-testid="formula-b12-card"
            className="group relative rounded-[28px] bg-[#1C1417] border border-white/10 p-8 sm:p-12 overflow-hidden hover:shadow-[0_30px_60px_-30px_rgba(28,20,23,0.6)] transition-shadow duration-500"
          >
            <div className="flex items-start justify-between">
              <Molecule tone="#E893AE" />
              <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#F4EBE6]/60 border border-white/15 rounded-full px-3 py-1.5">
                Active 02
              </span>
            </div>
            <p className="font-mono text-4xl sm:text-5xl text-[#E893AE] mt-8 tracking-tight">B12</p>
            <p className="font-serif text-2xl sm:text-3xl text-[#FAF7F5] mt-3">Vitamin B12</p>
            <p className="text-sm text-[#F4EBE6]/65 font-light leading-relaxed mt-4 max-w-md">
              An essential vitamin, paired with hyaluronic acid in a formula concept created around lip revitalisation
              and a fresh, healthy-looking lip appearance.
            </p>
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.24}>
        <div className="mt-8 rounded-3xl glass-panel p-6 sm:p-8 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-8">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#A31D4F] whitespace-nowrap">
            For professionals
          </p>
          <p className="text-sm text-[#6E6266] font-light leading-relaxed flex-1">
            Detailed product information, including composition and usage guidance, is available to eligible clinics
            and aesthetic professionals via Dermalis.
          </p>
          <Magnetic>
            <button
              data-testid="formula-cta-more"
              onClick={() => scrollToId("#contact")}
              className="btn-lux btn-lux-magenta whitespace-nowrap"
            >
              <span>Find Out More</span>
            </button>
          </Magnetic>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Formula;
